import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { postSignOut } from '../../../../api/auth/mutations/postSignOut';
import { usePopup } from '../../../popup/usePopup';

export const usePostSignOutMutation = () => {
  const navigate = useNavigate();
  const Popup = usePopup();

  return useMutation(postSignOut, {
    onSuccess: () => {
      Popup.alert({
        title: '탈퇴가 완료 되었어요 😥',
        content: '또 뵈었으면 좋겠습니다!',
        buttonArray: [
          {
            text: '확인',
            color: 'blue',
            onClick: () => navigate('/logout'),
          },
        ],
        close: () => navigate('/logout'),
      });
    },
  });
};
